import React, { useState } from "react";
import { Link } from "react-router-dom";

 const services = [
  { name: "Importer Exporter Code (IEC)", path: "/dgft/iec" },
   { name: "RCMC", path: "/dgft/rcmc" },
  { name: "Industrial Entrepreneur Memorandum (IEM)", path: "/dgft/iem" },
  { name: "DGFT Digital Signature (E-Token)", path: "/dgft/token" },
   { name: "Transport And Marketing Assistance (TMA)", path: "/dgft/tma" },
  { name: "Export Promotion Capital Goods (EPCG)", path: "/dgft/epcg" },
  { name: "Restricted Authorization for Import", path: "/dgft/restricted-import" },
  { name: "Restricted Authorization for Export", path: "/dgft/restricted-export" },
  { name: "SCOMET Authorisation", path: "/dgft/scomet" },
   { name: "Star Export House Certificate", path: "/dgft/status-house" },
  { name: "RoDTEP", path: "/dgft/rodtep" },
  { name: "MEIS", path: "/dgft/meis" },
  { name: "SEIS", path: "/dgft/seis" },
  { name: "Advance Authorisation (AA)", path: "/dgft/advance" },
  { name: "Duty-Free Import Authorisation (DFIA)", path: "/dgft/dfia" },
  
  { name: "Deemed Exports", path: "/dgft/deemed-exports" },
  { name: "Authorized Economic Operator Scheme", path: "/dgft/aeo" },
  // { name: "DGFT Miscellaneous Services", path: "/dgft/misc" },
];


export default function DGFTPage() {

  const [open, setOpen] = useState(null);

  return (
    <div className="dgft-page">

      {/* HERO */}
      <section className="dgft-hero">
        <div className="overlay">
          <div className="container">
            <h1>DGFT Services</h1>
            <p>Home Back » DGFT</p>
          </div>
        </div>
      </section>

      {/* MAIN */}
      <section className="dgft-main container">

        {/* LEFT SIDEBAR */}
        <aside className="dgft-left">

          <div className="left-menu-wrapper">

            <div className="left-menu-item active">
              <span>DGFT Liaisoning (EXIM)</span>
              <span>▸</span>
            </div>

           <Link to="/industrial-subsidies" className="left-menu-item">
  <span>Industrial Subsidies</span>
  <span>▸</span>
</Link>
              <span>Industrial Subsidies</span>
              <span>▸</span>
            </div>

         

        </aside>

        {/* RIGHT CONTENT */}
        <div className="dgft-right">

          {/* <h2>DGFT Consultants</h2>

          <p>
            One of the major issues faced by exporters and importers has always
            been dealing with licenses and other permissions that need to be
            obtained from the DGFT office, and the paperwork that is involved
            in the whole process, not to mention the complex channels one has
            to navigate.
          </p>

          <p>
            Apex is a well-known Export-Import License Consultant, offering
            an effective consultancy in DGFT matters related to both the import
            and export of all types of cargo.
          </p>

          <p>
            Our experts have been in the business of advising and facilitating
            export-import licenses for several years.
          </p>

          <h3>Below is a list of services provided in this segment :</h3> */}

          
            <h1>DGFT Consultants</h1>

            <p>
              Navigating international trade regulations in India can be complex.
              Businesses often require multiple licenses, approvals, and
              compliance with DGFT policies.
            </p>

            <p>
              From documentation to approvals, the process involves strict
              compliance, technical filings, and coordination with authorities.
            </p>

            <h2 className="section-title mt-4">
              Your Trusted DGFT Advisory Partner
            </h2>

            <p>
              At Apex Consultants, we provide end-to-end DGFT consultancy
              services, helping businesses simplify processes, ensure timely
              approvals, and reduce compliance risks.
            </p>

            <p>
              Our services support both new exporters and established businesses
              looking to streamline operations.
            </p>
         

          
                    

          {/* ACCORDION */}
          <div className="accordion">

           {services.map((item, index) => (
  <div key={index} className="acc-item">

    <Link
      to={item.path}
      className="acc-title"
      onClick={() => setOpen(open === index ? null : index)}
    >
      {item.name}
      <span>{open === index ? "−" : "+"}</span>
    </Link>

    {open === index && (
      <div className="acc-content">
        Detailed information about {item.name}.
      </div>
    )}

  </div>
))}

          </div>

        </div>

      </section>
    </div>
  );
}